import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isIOS, WEB_ORIGIN } from "@/lib/native";
import { FeaturePurchaseSheet } from "./FeaturePurchaseSheet";
import { FeaturedBadge } from "./FeaturedBadge";

export const FEATURE_PURCHASE_ALLOWED = !isIOS;

export function FeatureButton({ targetType, targetId, targetName, compact = false, testid = "feature-btn" }) {
  const { user } = useAuth();
  const [el, setEl] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    if (!user || !targetId) { setEl(null); return; }
    api.get("/featured/eligibility", { params: { target_type: targetType, target_id: targetId } }).then((r) => setEl(r.data)).catch(() => setEl(null));
  }, [user, targetType, targetId]);
  useEffect(() => { load(); }, [load]);

  if (!user || !el || !el.owner) return null;
  if (!FEATURE_PURCHASE_ALLOWED) {
    const site = WEB_ORIGIN || "https://angolauk.co.uk";
    return <div data-testid={`${testid}-web-only`} className="p-3 rounded-xl bg-zinc-50 border border-zinc-200 text-xs text-zinc-600">Destacar está disponível no site <a href={site} className="font-semibold underline text-black">{site.replace(/^https?:\/\//, "")}</a>.</div>;
  }
  if (!el.eligible) return <p data-testid={`${testid}-ineligible`} className="text-[11px] text-zinc-500">{el.reason}</p>;

  const active = el.active;
  return (
    <>
      {active ? (
        <div data-testid={`${testid}-active`} className="flex items-center justify-between gap-2 p-3 rounded-xl border border-zinc-200 bg-zinc-50 text-xs">
          <span className="flex items-center gap-2 min-w-0"><FeaturedBadge testid={`${testid}-active-badge`} /><span className="truncate">até {new Date(active.featured_ends_at).toLocaleDateString("pt-PT")}</span></span>
          <span className="flex items-center gap-2 shrink-0">
            <Link to="/destaques" data-testid={`${testid}-mine-link`} className="text-zinc-500 underline">Ver</Link>
            <button data-testid={`${testid}-extend`} onClick={() => setOpen(true)} className="px-3 py-1.5 rounded-lg bg-black text-white font-semibold hover:bg-[#c8102e] transition-colors">Prolongar</button>
          </span>
        </div>
      ) : (
        <button data-testid={testid} onClick={() => setOpen(true)}
                className={`${compact ? "px-3 py-1.5 text-[11px]" : "w-full py-3 text-sm"} flex items-center justify-center gap-2 rounded-xl border border-black bg-white text-black font-bold hover:bg-black hover:text-white transition-colors`}>
          <Sparkles size={14} /> Destacar
        </button>
      )}
      <FeaturePurchaseSheet open={open} onClose={() => { setOpen(false); load(); }} targetType={targetType} targetId={targetId} targetName={targetName || el.target_name} active={active} />
    </>
  );
}
